import { fetchEmbedData } from "./../../wix-ricos-common";
import { AUDIO_TYPE } from "./../../ricos-content";
function audioStrategy(instance, hasPlugin) {
  if (!instance || !hasPlugin(AUDIO_TYPE)) {
    return {
      config: {}
    };
  }
  return {
    config: {
      [AUDIO_TYPE]: {
        fetchData: fetchEmbedData(instance)
      }
    }
  };
}
export {
  audioStrategy as default
};
//# sourceMappingURL=audioStrategy.js.map
